import { render, staticRenderFns } from "./PersonTeam.vue?vue&type=template&id=59fe1c30&"
import script from "./PersonTeam.vue?vue&type=script&lang=js&"
export * from "./PersonTeam.vue?vue&type=script&lang=js&"
import style0 from "./PersonTeam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports